<template>
  <d-card class="card-small">
    <div
      v-if="!loaded"
      class="overlay-loading">
      <h2 class="preloader isLoading">Trwa ładowanie</h2>
    </div>
    <ExpenseTableHeader
      v-model="filters"
      :filters="filters"
      :users="allUsers"
      :cost-types="allCostTypes"
      @filter="filterList"
      @clear="clearFilters"
    />
    <ExpenseTableBody 
      :expenses="expenses"
      :pagination-meta-data="paginationMetaData"
      :current-page="currentPage"
      :lang="lang"
      :action-in-progress="actionInProgress"
    >
      <template v-slot:action="slotProps">
        <d-button
          @click.prevent="editExpense(slotProps.expense)"
          class="mr-2 mt-1 mb-1 ml-2"
          :disabled="actionInProgress"
        >
          <i class="material-icons">search</i> Edytuj
        </d-button>
      </template>
    </ExpenseTableBody>
  </d-card>
</template>

<script>
import HasFilters from '@/mixins/HasFilters.vue';
import HasPagination from '@/mixins/HasPagination.vue';
import ListUtils from '@/utils/ListUtils.js';
import { mapGetters, mapActions } from 'vuex'
import ExpenseTableHeader from '@/components/expense/list/molecules/ExpenseTableHeader.vue';
import ExpenseTableBody from '@/components/expense/list/molecules/ExpenseTableBody.vue';

export default {
  name: 'ExpensesTable',
  mixins: [HasFilters, HasPagination],
  components: {
    ExpenseTableHeader,
    ExpenseTableBody
},
  methods: {
    ...mapActions([
      'getAllUsers',
      'getAllCostTypes',
    ]),
    clearFilters () {
      Vue.set(this, 'loaded', false);
      Vue.set(this, 'loadError', false);
      this.filters = {
        user_id: '',
        expenses_cost_type: '',
        search: '',
        cash_refunded: '',
        transfer_complete: '',
      };

      this.$bus.$emit('view-filters-reset');
      this.$bus.$emit('pagination-reset');
    },
    filterList () {
      Vue.set(this, 'loaded', false);
      Vue.set(this, 'loadError', false);
      this.$bus.$emit('pagination-reset');
      this.$bus.$emit('view-filters-save');
    },
    debouncedLoadFilteredData: _.debounce(function () {
      Vue.set(this, 'loaded', false);
      Vue.set(this, 'loadError', false);
      this.loadItemsData();
    }, 500),  
    loadItemsData () {
      ListUtils.loadItemsData(this, {
        method: 'post',
        endpoint: '/api/expenses/items',
        listField: 'expenses',
        pagination: true,
        params: {
          page: this.currentPage,
          where: {
            ...this.filters,
            schedule_id: this.$route.params.schedule_id
          },
          short: true
        }
      });
    },
    editExpense (expense) {
      const { href } =  this.$router.resolve({name: 'expense-edit', params: {id: expense.id}})
      window.open(href, '_blank')
    },
    updateExpense(expense) {
      axios.post('api/expenses/update/' + expense.id, expense).catch((error) =>{
        LarErrors.record(error.response.data.errors)
      })
    },  
  },
  computed: {
    ...mapGetters([
      'allUsers',
      'allCostTypes',
    ]),
  },
  mounted () {
    this.loadItemsData();
    this.getAllUsers();
    this.getAllCostTypes()
  },
  data(){
    return {
      actionInProgress: false,
      filters: {
        cash_refunded: '',
        expenses_cost_type: '',
        search: '',
        transfer_complete: '',
        user_id: '',
      },
      lang: {
        cash: 'Gotówka',
        transfer: 'Przelew'
      },
      loaded: false,
      loadError: false,
      expenses: [],
      current_page: 1,
      last_page: 1,
    }
  }
}
</script>
